import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import buildPATHS from './paths';
import { FixMeLater } from '../temporary-types';
import { registerAccessSelector } from '../store/selectors/appSelectors';
import { IAppProps } from '../App';

interface IGuardRegistrationFormProps extends IAppProps {
  component: FixMeLater;
  path: string;
}

const GuardRegisterForm: React.FC<IGuardRegistrationFormProps> = (
  props: IGuardRegistrationFormProps,
) => {
  const { component: Component, path } = props;

  const registerAccess: boolean = useSelector(registerAccessSelector);
  const PATHS = buildPATHS();

  return (
    <Route
      exact
      path={path}
      render={(props: any) =>
        registerAccess ? (
          <Component {...props} />
        ) : (
          <Redirect to={PATHS.welcome} />
        )
      }
    />
  );
};

GuardRegisterForm.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
};

export default GuardRegisterForm;
